import angular from "angular";

export class AccountingPlanService {
    accountingPlanEntity = null;
    features = {
        AgenteConsultivo: false,
        Themes: false,
        IAContador: false,
        IAShortcutsAccounting: false,
        IAEmployee: false,
        AutomaticParameterization: false,
        AnalysisPlus: false
    };

    constructor() {}

    init({ accountingPlanEntity }) {
        this.reset();
        if (!accountingPlanEntity) {
            return;
        }
        this.accountingPlanEntity = accountingPlanEntity;
        this.setFeatures();
    }

    setFeatures() {
        const features = Object.keys(this.features);
        for (const feature of features) {
            this.features[
                feature
            ] = this.accountingPlanEntity.isContractedFeature({
                value: feature
            });
        }
    }

    reset() {
        this.accountingPlanEntity = null;
        const features = Object.keys(this.features);
        for (const feature of features) {
            this.features[feature] = false;
        }
    }
}

angular.module("nucont.shared")
    .service("AccountingPlanService", [AccountingPlanService]);
